import React, { Component } from 'react'
import api from '../api/api'

import { withStyles } from '@mui/styles';

import AddCircleIcon from '@mui/icons-material/AddCircle'
import CloseIcon from '@mui/icons-material/Close'
import DeleteIcon from '@mui/icons-material/Delete'
import EditIcon from '@mui/icons-material/Edit';
import HealingIcon from '@mui/icons-material/Healing';
import {
  AppBar,
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  Grid,
  IconButton,
  Menu,
  MenuItem,
  Slide,
  TextField,
  Toolbar,
  Tooltip,
  Typography,
} from '@mui/material'

import { grey, red } from '@mui/material/colors'

import { DataGrid } from '@mui/x-data-grid'
import AssessmentEditor from './visit/AssessmentEditor.jsx';
import SignaturePad from './common/SignaturePad.jsx'

const styles = (theme) => ({
  appBar: {
    position: 'static',
  },
  bullet: {
    display: 'inline-block',
    margin: '0 2px',
    transform: 'scale(0.8)',
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
  content: {
    flexGrow: 1,
    padding: theme.spacing(3),
  },
  dialogBusyOverlay: {
    position: 'fixed',
    inset: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: 'rgba(250, 250, 250, 0.55)',
    zIndex: 1400,
  },
  dialogStyle: {
    maxWidth: '50%',
  },
  error: {
    fontSize: '20px',
    color: red[400],
  },
  floatingButton: {
    bottom: 0,
    right: 0,
  },
  form: {
    backgroundColor: '#fafafa',
    width: '98%',
    marginLeft: 13,
    marginTop: theme.spacing(3),
  },
  formTextField: {
    backgroundColor:'#ffffff',
    fontSize: 14,
  },
  signatureMeta: {
    marginTop: theme.spacing(1),
    color: theme.palette.text.secondary,
  },
  input: {
    marginBottom: 20,
  },
  patientGrid: {
    background: 'linear-gradient(45deg, #cb5921D0 30%, #a99787D0 90%)',
  },
  pos: {
    marginBottom: 12,
  },
  root: {
    minWidth: 470,
  },
  submitButton: {
    display: 'block',
    color: 'white',
    textAlign: 'center',
    position: 'absolute',
    right: 10,
  },
  downloadButton: {
    display: 'block',
    color: 'white',
    textAlign: 'center',
    position: 'absolute',
    right: 110,
  },
  subTitle: {
    fontSize: '22px',
    width: 120,
    color: grey[800],
    top: 20,
    bottom: 20,
    background: 'linear-gradient(45deg, #cb5921D0 30%, #a99787D0 90%)',
    borderRadius: '8px',
  },
  title: {
    marginLeft: theme.spacing(2),
    flex: 1,
  },
  toolbar: theme.mixins.toolbar,
  uiProgess: {
    position: 'fixed',
    zIndex: '1000',
    height: '31px',
    width: '31px',
    left: '50%',
    top: '35%',
  },
  viewRoot: {
    margin: 0,
    padding: theme.spacing(2),
  },
})

const Transition = React.forwardRef((props, ref) => (
  <Slide direction="up" {...props} ref={ref} />
))

const patientColumns = [
  {
    field: 'patientName',
    headerName: 'Surname',
    width: 170,
    editable: false,
  },
  {
    field: 'firstName',
    headerName: 'First Name',
    width: 170,
    editable: false,
  },
  {
    field: 'SAID',
    headerName: 'ID/Passport number',
    width: 170,
    editable: false,
  },
  {
    field: 'medicalAid',
    headerName: 'Medical Aid',
    width: 170,
    editable: false,
  },
  {
    field: 'memberNo',
    headerName: 'Member Number',
    width: 170,
    editable: false,
  },
]


const createEmptyPatient = () => ({
  id: Math.random(),
  SAID: '',
  authNo:'',
  companyName: '',
  dateOfBirth: '',
  dependentCode: '',
  email: '',
  firstName: '',
  gender: '',
  homeAddrCode: '',
  homeAddress: '',
  ICD10Codes: '',
  married: '',
  medicalAid: '',
  memberNo: '',
  mobile: '',
  nationality: '',
  nextOfKin: '',
  nextOfKinNo: '',
  occupation: '',
  patientName: '',
  planType: '',
  principalAddrCode: '',
  principalAddress: '',
  principalFirstName: '',
  principalHomeTel: '',
  principalId: '',
  principalMember: '',
  principalMobile: '',
  principalName: '',
  principalWorkTel: '',
  referringDoctor: '',
  referringDrNo: '',
  signatureDataUrl: '',
  signatureSignedAt: '',
  workAddress: '',
  workAddrCode: '',
  workTel: '',
  authStatus: 'not_started',
  authMonth: '',
})

const assessment0 = {
  // Legacy fields
  allergies: '',
  balance: 'unknown',
  comorbidities: '',
  depth: 1,
  education: '',
  exudateLevel: '1',
  exudateType: '',
  healingFactors: '',
  healthEducation: '',
  infection: false,
  inflammation: false,
  length: 1,
  margin: 'unknown',
  medInfo: '',
  medications: '',
  mobility: '',
  nutrition: '',
  painLevel: 0,
  patientId: '',
  postsurgical: false,
  SAID: '',
  site: '',
  smoking: '',
  treatment: '',
  treatmentPlan: '',
  type: '',
  viability: 'unknown',
  visitId: '',
  weight: 0,
  width: 1,
  // New assessment overlay fields
  woundStartDate: '',
  treatmentStartDate: '',
  woundLocation: '',
  diabeticUlcer: false,
  pressureUlcer: false,
  venousUlcer: false,
  trauma: false,
  burns: false,
  other: false,
  surgicalProc: '',
  dstage: '',
  pstage: '',
  vstage: '',
  traumaDesc: '',
  burnDegree1: false,
  burnDegree2: false,
  burnDegree3: false,
  burnArea: '',
  cellulitis: false,
  colonised: false,
  superficial: false,
  nerds: {},
  stones: {},
  serous: '',
  sanguineous: '',
  serosang: '',
  purulent: '',
  otherDesc: '',
  // Discovery wound assessment fields
  outpatientPracticeNo: '',
  bodyAnnotation: '',
  fistulae: false,
  pilonidalCyst: false,
  skinCancer: false,
  arterialUlcer: false,
  gangren: false,
  skinGrafting: false,
  healableWound: false,
  maintenanceWound: false,
  nonHealableWound: false,
  healabilityOther: '',
  siteOfWound: '',
  sizeOfWound: '',
  woundLength: '',
  woundWidth: '',
  woundDepth: '',
  woundVolume: '',
  woundUndermining: '',
  epithelialisation: false,
  granulation: false,
  slough: false,
  blackNecrotic: false,
  overGranulating: false,
  fungating: false,
  mixedTissue: false,
  biofilm: false,
  exudateColour: '',
  exudateAmount: '',
  skinHealthy: false,
  skinDry: false,
  skinDiscoloured: false,
  skinErythema: false,
  skinMacerated: false,
  skinCallous: false,
  skinOedematous: false,
  woundPhaseInflammatory: false,
  woundPhaseProliferation: false,
  woundPhaseMaturation: false,
  painFrequency: '',
  treatmentGoals: {},
  treatmentDates: '',
  includePhoto: false,
  clinicalMotivation: false,
  quotation: false,
  assessmentSignatureDataUrl: '',
  assessmentSignatureDate: '',
}

const validatePatient = ({
  SAID,
  email,
  firstName,
  patientName,
  mobile,
  medicalAid,
  memberNo,
  referringDoctor,
  referringDrNo,
}, medicalAidNames = []) => {
  const hasMedicalAidList = medicalAidNames.length > 0;
  const hasValue = (value) => String(value || '').trim() !== ''
  const errors = {
    SAID: !hasValue(SAID),
    email: !hasValue(email),
    firstName: !hasValue(firstName),
    patientName: !hasValue(patientName),
    mobile: !hasValue(mobile),
    medicalAid:
      !hasValue(medicalAid) ||
      (hasMedicalAidList && !medicalAidNames.includes(String(medicalAid).trim())),
    memberNo: !hasValue(memberNo),
    referringDoctor: !hasValue(referringDoctor),
    referringDrNo: !hasValue(referringDrNo),
  };

  const hasErrors = Object.values(errors).some(Boolean);
  return { errors, hasErrors };
};

const normalizePatient = (patient, groupId) => {
  const {
    id,
    SAID,
    firstName,
    patientName,
    ICD10Codes,
    ...rest
  } = patient;

  return {
    id,
    ...rest,
    SAID: SAID.replace(/\s+/g, ''),
    firstName: firstName.trim(),
    patientName: patientName.trim(),
    groupId,
    ICD10Codes:
      ICD10Codes && ICD10Codes.trim() !== ''
        ? ICD10Codes
        : 'T81.4 and Y83.8, Z48.0',
  };
};


class patient extends Component {
  constructor(props) {
    super(props)

    this.state = {
      assessment: { ...assessment0 },
      assessmentDialogOpen: false,
      assessmentMode: 'Create',
      buttonType: '',
      deleteModeOn: false,
      deleteInfo: 0,
      displaySubMenuButtons: 0,
      error: false,
      errors: [],
      fieldname: '',
      fieldvalue: null,
      filter: '',
	    login: false,
      mouseX: null,
      mouseY: null,
      medicalAids: [],
      open: false,
      opendel: false,
      patients: [],
      patient: {},
      patientGridFilterModel: { items: [] },
      uiLoading: true,
      userfeedback: '',
      viewOpen: false,
    }

    this.latestAssessment = this.state.assessment
    this.persistedAssessment = this.state.assessment
    this.assessmentEditorRef = null
  }

  sanitizeFileNamePart = (value) => String(value || '')
    .trim()
    .replace(/[^a-z0-9._-]+/gi, '_')
    .replace(/^_+|_+$/g, '')

  downloadPdfFromBase64 = (base64, fileName) => {
    const byteCharacters = window.atob(base64)
    const byteNumbers = new Array(byteCharacters.length)
    for (let i = 0; i < byteCharacters.length; i += 1) {
      byteNumbers[i] = byteCharacters.charCodeAt(i)
    }
    const byteArray = new Uint8Array(byteNumbers)
    const blob = new Blob([byteArray], { type: 'application/pdf' })
    const url = window.URL.createObjectURL(blob)
    const link = document.createElement('a')
    link.href = url
    link.download = fileName
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
    window.URL.revokeObjectURL(url)
  }

  handleDownloadAssessmentPdf = async () => {
    if (!this.assessmentEditorRef) {
      this.setState({ userfeedback: 'Assessment content is not available yet.' })
      return
    }

    try {
      this.setState({ uiLoading: true, userfeedback: '' })
      const { generatePdfAttachmentFromElement } = await import('../util/generatePdfAttachment')
      const currentAssessment = this.latestAssessment || this.state.assessment || {}
      const patientName = this.sanitizeFileNamePart(this.state.patient?.patientName || 'patient')
      const firstName = this.sanitizeFileNamePart(this.state.patient?.firstName || '')
      const datePart = this.sanitizeFileNamePart(currentAssessment.assessmentSignatureDate || new Date().toISOString().slice(0, 10))
      const pdfName = `${patientName}_${firstName}_${datePart}_wound_assessment.pdf`

      const attachment = await generatePdfAttachmentFromElement(this.assessmentEditorRef, pdfName)
      if (!attachment?.attachmentBase64) {
        this.setState({ userfeedback: 'Unable to generate PDF from the assessment form.' })
        return
      }

      this.downloadPdfFromBase64(attachment.attachmentBase64, attachment.attachmentName || pdfName)
    } catch (error) {
      this.setState({ userfeedback: 'Failed to download assessment PDF.' })
      console.log('Failed to generate assessment PDF:', error)
    } finally {
      this.setState({ uiLoading: false })
    }
  }

  openAssessmentEditor = async () => {
    const selectedPatient = this.state.patient || {}
    const patientId = selectedPatient.id

    if (!patientId) {
      this.setState({ userfeedback: 'Select a patient first.' })
      return
    }

    try {
      this.setState({
        uiLoading: true,
        userfeedback: '',
      })

      const response = await api.get(`/assessment/patient/${patientId}`)
      if (response.data.length > 0) {
        const assessment = { ...assessment0, ...response.data[0] }
        this.latestAssessment = assessment
        this.persistedAssessment = assessment
        this.setState({
          assessment,
          assessmentDialogOpen: true,
          assessmentMode: 'Edit',
          uiLoading: false,
        })
        return
      }

      const assessment = {
        ...assessment0,
        patientId,
        SAID: selectedPatient.SAID || '',
      }
      this.latestAssessment = assessment
      this.persistedAssessment = assessment
      this.setState({
        assessment,
        assessmentDialogOpen: true,
        assessmentMode: 'Create',
        uiLoading: false,
      })
    } catch (error) {
      if (error.response?.status === 403) {
        this.setState({ login: true })
      } else {
        console.log(error)
      }
      this.setState({ uiLoading: false })
    }
  }

  handleCloseAssessment = () => {
    const assessment = { ...(this.persistedAssessment || assessment0) }
    this.latestAssessment = assessment
    this.setState({
      assessment,
      assessmentDialogOpen: false,
      assessmentMode: assessment.id ? 'Edit' : 'Create',
      userfeedback: '',
    })
  }

  handleChangeAssessment = (event) => {
    const assessment = { ...(this.latestAssessment || this.state.assessment) }
    if (event.target.type === 'checkbox') {
      assessment[event.target.name] = event.target.checked
    } else {
      assessment[event.target.name] = event.target.value
    }
    this.latestAssessment = assessment
    this.setState({ assessment })
  }

  handleCreateOrUpdateAssessment = async () => {
    const currentAssessment = this.latestAssessment || this.state.assessment
    const selectedPatient = this.state.patient || {}
    const patientId = selectedPatient.id || currentAssessment.patientId
    const SAID = selectedPatient.SAID || currentAssessment.SAID

    if (!patientId || !SAID) {
      this.setState({ userfeedback: 'Select a patient first.' })
      return
    }

    try {
      this.setState({ uiLoading: true, userfeedback: '' })

      const data = {
        ...currentAssessment,
        patientId,
        SAID,
        visitId: currentAssessment.visitId || '',
      }

      if (this.state.assessmentMode === 'Edit' && data.id) {
        const assessmentId = data.id
        delete data.id
        await api.put(`/assessment/${assessmentId}`, data)
      } else {
        delete data.id
        const response = await api.post('/assessment/patient', data)
        data.id = response.data.id
      }

      this.setState({
        assessment: data,
        assessmentDialogOpen: false,
        assessmentMode: 'Edit',
        uiLoading: false,
      })
      this.latestAssessment = data
      this.persistedAssessment = data
    } catch (error) {
      if (error.response?.status === 403) {
        this.setState({ login: true })
      } else {
        console.log(error)
      }
      this.setState({ uiLoading: false })
    }
  }

  handleDeleteAssessment = async () => {
    const selectedPatient = this.state.patient || {}
    const patientId = selectedPatient.id || this.state.assessment.patientId

    if (!patientId) {
      this.setState({ userfeedback: 'Select a patient first.' })
      return
    }

    try {
      this.setState({ uiLoading: true, userfeedback: '' })
      const assessmentResponse = await api.get(`/assessment/patient/${patientId}`)

      if (assessmentResponse.data.length > 0) {
        await api.delete(`/assessment/${assessmentResponse.data[0].id}`)
      }

      this.setState({
        assessment: {
          ...assessment0,
          patientId,
          SAID: selectedPatient.SAID || '',
        },
        assessmentDialogOpen: false,
        assessmentMode: 'Create',
        uiLoading: false,
      })
      this.latestAssessment = {
        ...assessment0,
        patientId,
        SAID: selectedPatient.SAID || '',
      }
      this.persistedAssessment = this.latestAssessment
    } catch (error) {
      if (error.response?.status === 403) {
        this.setState({ login: true })
      } else {
        console.log(error)
      }
      this.setState({ uiLoading: false })
    }
  }

  fetchPatients = async () => {
    try {
      const response = await api.get(`/patients/group/${this.props.groupId}`)
      this.setState({
        patients: response.data,
        uiLoading: false,
      })
    } catch (error) {
      if (error.response.status === 403) {
        this.setState({login: true})
      }
      else {
        this.setState({ uiLoading: false })
        console.log(error)
      }
    }
  }

  fetchMedicalAid = async () => {
    try {
      const response = await api.get('/medicalAids/')
      this.setState({ medicalAids: response.data || [] })
    } catch (error) {
      if (error.response?.status === 403) {
        this.setState({ login: true })
      } else {
        console.log(error)
      }
    }
  }

  async createPatient(userpatient) {
  const duplicate = this.state.patients.some(
    (p) => p.SAID === userpatient.SAID
  );

  if (duplicate) {
    this.setState({
      errors: { SAID: true },
      userfeedback: '!!! Duplicate SAID detected !!!',
      uiLoading: false,
    });
    return;
  }

  this.setState({ userfeedback: '' });

  const response = await api.post('/patient', userpatient);

  this.setState((prev) => ({
    buttonType: 'Edit',
    patient: response.data,
    patients: [response.data, ...prev.patients],
    uiLoading: false,
  }));
}

async updatePatient(id, userpatient) {
  await api.put(`/patient/${id}`, userpatient);

  this.setState((prev) => {
    const updatedPatient = { ...userpatient, id };

    return {
      open: false,
      patient: updatedPatient,
      patients: prev.patients.map((p) =>
        p.id === id ? updatedPatient : p
      ),
      uiLoading: false,
    };
  });
}

handleCreateOrEditPatient = async (event) => {
  event.preventDefault();

  const normalized = normalizePatient(
    this.state.patient,
    this.props.groupId
  );

  const { id, ...userpatient } = normalized;

  const medicalAidNames = this.state.medicalAids
    .map((item) => item.name)
    .filter(Boolean);
  const { errors, hasErrors } = validatePatient(userpatient, medicalAidNames);
  this.setState({ errors });

  if (hasErrors) return;

  this.setState({ uiLoading: true });

  try {
    if (this.state.buttonType === 'Edit') {
      await this.updatePatient(id, userpatient);
    } else {
      await this.createPatient(userpatient);
    }
  } catch (error) {
    if (error.response?.status === 403) {
      this.setState({ login: true });
    } else {
      this.setState({ uiLoading: false });
      console.error(error);
    }
  }
};

  handleDeletePatient = async () => {

    const patientId = this.state.patient.id
    try{
      this.setState({ uiLoading: true })
      await api.delete(`/patient/${patientId}`)
      const patients = [...this.state.patients.filter((x) => x.id !== patientId)]
      this.setState({ 
        deleteInfo:1,
        displaySubMenuButtons:0, 
        mouseX:null,
        mouseY:null,
        opendel:false,
        uiLoading: false,
        patients,
      })
    } catch (error) {
      if (error.response.status === 403) {
        this.setState({login: true})
      }
      else {
        this.setState({ uiLoading: false })
        console.log(error)
      }
    }
  }

  componentDidMount = () => {
    this.fetchPatients()
    this.fetchMedicalAid()
  }

  handleChange = (event) => {
    const patient = {...this.state.patient};
    patient[event.target.name] = event.target.value;
    this.setState({patient});
  }

  handleSignatureChange = (signatureDataUrl) => {
    this.setState((prev) => ({
      patient: {
        ...prev.patient,
        signatureDataUrl,
      },
    }))
  }

  handleSignatureSignedAtChange = (signatureSignedAt) => {
    this.setState((prev) => ({
      patient: {
        ...prev.patient,
        signatureSignedAt,
      },
    }))
  }

  handleClickToCreate = () => {
    this.setState({
      buttonType: 'Create',
      deleteInfo:0,
      displaySubMenuButtons:0,
      open: true,
      patient: createEmptyPatient()
    })
  }

  handleClickToDelete = () => {
    this.setState({
      errors: {},
      mouseX: null,
      mouseY: null,
      opendel: true,
    })
  }

  handleClickToEdit = () => {
    this.setState({
      errors: {},
      mouseX: null,
      mouseY: null,
      open: true,
      buttonType: 'Edit'
    })
  }
  
  handleClose = (event) => {
    this.setState({ 
      open: false,
      opendel: false,
      mouseX: null,
      mouseY: null,
      })
  }

  handleDoubleClick = (event) => {
    const mouseX = this.state.mouseX ? null : event.clientX - 2
    const mouseY = this.state.mouseY ? null : event.clientY - 4
    this.setState({
      displaySubMenuButtons:0,
      mouseX, 
      mouseY
    })
  }
  
  handleSingleClick = (event) => {
    this.setState({displaySubMenuButtons:1})
  }

  handleCMenuClose = () => {
    this.setState({
      mouseX: null,
      mouseY: null,
      displaySubMenuButtons:0
    })
  }

  handlePatientFilterModelChange = (filterModel) => {
    this.setState({ patientGridFilterModel: filterModel })
  }

  fetchKey = (event) => {
    this.setState({
      deleteInfo:0,
      userfeedback: '',
      patient: event.row,
    })
  }


  render() {
    const { classes } = this.props
    const { open, opendel, errors } = this.state
    const showPageLoading = this.state.uiLoading && !open && !this.state.assessmentDialogOpen
    const medicalAidOptions = this.state.medicalAids
      .map((item) => item.name)
      .filter(Boolean)

    const DeleteDialog = (
      <Dialog
        open={opendel}
        onClose={this.handleClose}
      >
        <DialogContent>
          <DialogContentText>
              Deleting a patient will impair the ability to handle any of the patient's visits! Continue delete? 
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button autoFocus onClick={this.handleClose}>
            Cancel
          </Button>
          <Button onClick={this.handleDeletePatient}>
            Confirm
          </Button>
        </DialogActions>
      </Dialog>
    )
  
    const Error =
      this.state.error === false ? (
        <div className={classes.subTitle}>&nbsp;PATIENTS</div>
      ) : (
        <div className={classes.error}>{this.state.error}</div>
      )

    const addButton = (
     <Tooltip title="Add Patient" placement="top">
      <IconButton
        className={classes.floatingButton}
        color="primary"
        aria-label="Add Patient"
        onClick={this.handleClickToCreate}
        size="large"
      >
        <AddCircleIcon style={{ fontSize: 60 }} />
      </IconButton>
     </Tooltip>
    )
  
    const editButton = (
     <Tooltip title="Edit Patient" placement="top">
      <IconButton
            className={classes.floatingButton}
            color="primary"
            aria-label="Patient Details"
            onClick={this.handleClickToEdit}
            size="large"
      >
        <EditIcon style={{ fontSize: 60 }} />
      </IconButton>
     </Tooltip>
    )

    const deleteButton = (
     <Tooltip title="Delete Patient" placement="top">
      <IconButton
        className={classes.floatingButton}
        color="primary"
        aria-label="Delete Patient"
        onClick={this.handleClickToDelete}
        size="large"
      >
        <DeleteIcon style={{ fontSize: 60 }} />
      </IconButton>
     </Tooltip>
    ) 

    const assessmentButton = (
      <Tooltip title="Patient Wound Assessment" placement="top">
        <IconButton
          className={classes.floatingButton}
          color="primary"
          aria-label="Patient Wound Assessment"
          onClick={this.openAssessmentEditor}
          size="large"
        >
          <HealingIcon style={{ fontSize: 60 }} />
        </IconButton>
      </Tooltip>
    )

    const deleteInfo = this.state.deleteInfo ? (
      <Button
        className={classes.floatingButton}
        color="primary"
      >
        Delete Successful  
      </Button>
    ) : ''

    const subMenuButtons = this.state.displaySubMenuButtons ? (
      <div>
        {addButton}
        {editButton}
        {assessmentButton}
        {deleteButton}
        {deleteInfo}
      </div>
    ) : (
      <div>
        {addButton}
        {deleteInfo}
    </div>
    )

    const contextMenu = (
      <Menu
        className={classes.contextMenu}
        keepMounted
        open={this.state.mouseY !== null}
        onClose={this.handleCMenuClose}
        anchorReference="anchorPosition"
        anchorPosition={
          this.state.mouseY !== null && this.state.mouseX !== null
            ? { top: this.state.mouseY, left: this.state.mouseX }
            : undefined
        }
      >
        <MenuItem onClick={this.handleClickToEdit}>Patient Details</MenuItem>
        <MenuItem onClick={this.openAssessmentEditor}>Wound Assessment</MenuItem>
        <MenuItem >---------------</MenuItem>
        <MenuItem onClick={this.handleClickToDelete}>Delete Patient</MenuItem>
      </Menu>
    )


    return (
      <main className={classes.content}>
        <div className={classes.toolbar} />
        {showPageLoading && (
          <CircularProgress size={150} className={classes.uiProgess} />
        )}
        <div>
          {Error}
          {subMenuButtons}
        </div>
        <div
//            onContextMenu={handleRightClick}
          onDoubleClick={this.handleDoubleClick}
          onClick={this.handleSingleClick}
          style={{ cursor: 'context-menu' }}
        >
          {contextMenu}
          <div style={{ width: '660pt', height: '580pt' }}>
            <DataGrid
              className={classes.patientGrid}
              rows={this.state.patients}
              columns={patientColumns}
              filterModel={this.state.patientGridFilterModel}
              isRowSelectable={() => true}
              onFilterModelChange={this.handlePatientFilterModelChange}
              // checkboxSelection
              // disableSelectionOnClick
              // onSelectionModelChange={handleSelectionChange}
              // onCellDoubleClick={handleClickToEdit}
              onCellClick={this.fetchKey}
            />
          </div>
        </div>
        {DeleteDialog}
        <Dialog
          fullScreen
          open={open}
          onClose={this.handleClose}
          TransitionComponent={Transition}
        >
						<AppBar position="static">
              <Toolbar variant="dense">

                <Tooltip title="Close Modal" placement="top">
                  <IconButton
                    edge="start"
                    color="inherit"
                    onClick={this.handleClose}
                    aria-label="close"
                    size="large"
                  >
                    <CloseIcon />
                  </IconButton>
                </Tooltip>
                <Typography variant="h6" className={classes.title}>
                  {this.state.buttonType === 'Edit'
                    ? 'Edit a patient'
                    : 'Create a new patient' + this.state.userfeedback}
                </Typography>
                <Button
                  autoFocus
                  color="inherit"
                  onClick={this.handleCreateOrEditPatient}
                  className={classes.submitButton}
                >
                  {this.state.buttonType === 'Edit' ? 'Save' : 'Submit'}
                </Button>
              </Toolbar>
            </AppBar>

            <form className={classes.form} noValidate>
              <Grid container spacing={1}>
                <Grid item xs={6}>
                  <TextField
                    className={classes.formTextField}
                    variant="outlined"
                    id="gender"
                    label="Title"
                    name="gender"
                    autoComplete="gender"
                    helperText={errors.gender}
                    value={this.state.patient.gender}
                    error={errors.gender ? true : false}
                    onChange={this.handleChange}
                  >
                  </TextField>
                </Grid>
                <Grid item xs={6}>
                  <TextField
                    className={classes.formTextField}
                    variant="outlined"
                    required
                    id="patientName"
                    label="Surname"
                    name="patientName"
                    autoComplete="patientName"
                    helperText={errors.patientName}
                    value={this.state.patient.patientName}
                    error={errors.patientName ? true : false}
                    onChange={this.handleChange}
                  />
                </Grid>
                <Grid item xs={6}>
                  <TextField
                    className={classes.formTextField}
                    variant="outlined"
                    required
                    id="firstName"
                    label="First Name"
                    name="firstName"
                    autoComplete="firstName"
                    helperText={errors.firstName}
                    value={this.state.patient.firstName}
                    error={errors.firstName ? true : false}
                    onChange={this.handleChange}
                  />
                </Grid>
                <Grid item xs={6}>
                  <TextField
                    className={classes.formTextField}
                    variant="outlined"
                    required
                    id="dateOfBirth"
                    label="Date of birth"
                    name="dateOfBirth"
                    autoComplete="dateOfBirth"
                    type="date"
                    helperText={errors.dateOfBirth}
                    value={this.state.patient.dateOfBirth}
                    error={errors.dateOfBirth ? true : false}
                    onChange={this.handleChange}
                  />
                </Grid>
                <Grid item xs={6}>
                  <TextField
                    className={classes.formTextField}
                    variant="outlined"
                    required
                    id="SAID"
                    label="ID/Passport number"
                    name="SAID"
                    autoComplete="SAID"
                    helperText={errors.SAID}
                    value={this.state.patient.SAID}
                    error={errors.SAID ? true : false}
                    onChange={this.handleChange}
                  />
                </Grid>
                <Grid item xs={6}>
                  <TextField
                    className={classes.formTextField}
                    variant="outlined"
                    required
                    id="medicalAid"
                    label="Medical Aid"
                    name="medicalAid"
                    select
                    helperText={
                      errors.medicalAid
                        ? 'Select a valid medical aid from the list'
                        : ''
                    }
                    value={this.state.patient.medicalAid || ''}
                    error={errors.medicalAid ? true : false}
                    onChange={this.handleChange}
                  >
                    <MenuItem value="">Select Medical Aid</MenuItem>
                    {medicalAidOptions.map((name) => (
                      <MenuItem key={name} value={name}>
                        {name}
                      </MenuItem>
                    ))}
                  </TextField>
                </Grid>
                <Grid item xs={6}>
                  <TextField
                    className={classes.formTextField}
                    variant="outlined"
                    id="authStatus"
                    label="Auth Status"
                    name="authStatus"
                    select
                    value={this.state.patient.authStatus || 'not_started'}
                    onChange={this.handleChange}
                  >
                    <MenuItem value="not_started">Not Started</MenuItem>
                    <MenuItem value="pending">Pending</MenuItem>
                    <MenuItem value="authorized">Authorized</MenuItem>
                    <MenuItem value="declined">Declined</MenuItem>
                  </TextField>
                </Grid>
                <Grid item xs={6}>
                  <TextField
                    className={classes.formTextField}
                    variant="outlined"
                    id="authMonth"
                    label="Auth Month (mm-dd)"
                    name="authMonth"
                    placeholder="e.g., 03-15"
                    value={this.state.patient.authMonth || ''}
                    onChange={this.handleChange}
                  />
                </Grid>
                <Grid item xs={6}>
                  <TextField
                    className={classes.formTextField}
                    variant="outlined"
                    id="authNo"
                    label="Authorization Number"
                    name="authNo"
                    autoComplete="authNo"
                    helperText={errors.authNo}
                    value={this.state.patient.authNo}
                    error={errors.authNo ? true : false}
                    onChange={this.handleChange}
                  />
                </Grid>
                <Grid item xs={6}>
                  <TextField
                    className={classes.formTextField}
                    variant="outlined"
                    required
                    id="ICD10Codes"
                    label="ICD10 Codes"
                    name="ICD10Codes"
                    autoComplete="ICD10Codes"
                    helperText={errors.ICD10Codes}
                    value={this.state.patient.ICD10Codes}
                    error={errors.ICD10Codes ? true : false}
                    onChange={this.handleChange}
                  />
                </Grid>
                <Grid item xs={6}>
                  <TextField
                    className={classes.formTextField}
                    variant="outlined"
                    required
                    id="homeAddress"
                    label="Home Address"
                    name="homeAddress"
                    helperText={errors.homeAddress}
                    value={this.state.patient.homeAddress}
                    error={errors.homeAddress ? true : false}
                    onChange={this.handleChange}
                  />
                </Grid>
                <Grid item xs={6}>
                  <TextField
                    className={classes.formTextField}
                    variant="outlined"
                    required
                    id="homeAddrCode"
                    label="Home Address Code"
                    name="homeAddrCode"
                    autoComplete="homeAddrCode"
                    helperText={errors.homeAddrCode}
                    value={this.state.patient.homeAddrCode}
                    error={errors.homeAddrCode ? true : false}
                    onChange={this.handleChange}
                  />
                </Grid>
                <Grid item xs={6}>
                  <TextField
                    className={classes.formTextField}
                    variant="outlined"
                    required
                    id="mobile"
                    label="Mobile Number"
                    name="mobile"
                    autoComplete="mobile"
                    helperText={errors.mobile}
                    value={this.state.patient.mobile}
                    error={errors.mobile ? true : false}
                    onChange={this.handleChange}
                  />
                </Grid>
                <Grid item xs={6}>
                  <TextField
                    className={classes.formTextField}
                    variant="outlined"
                    id="workTel"
                    label="Work Tel"
                    name="workTel"
                    autoComplete="workTel"
                    helperText={errors.workTel}
                    value={this.state.patient.workTel}
                    error={errors.workTel ? true : false}
                    onChange={this.handleChange}
                  />
                </Grid>
                <Grid item xs={6}>
                  <TextField
                    className={classes.formTextField}
                    variant="outlined"
                    required
                    id="email"
                    label="Email Address"
                    name="email"
                    autoComplete="email"
                    helperText={errors.email}
                    value={this.state.patient.email}
                    error={errors.email ? true : false}
                    onChange={this.handleChange}
                  />
                </Grid>
                <Grid item xs={6}>
                  <TextField
                    className={classes.formTextField}
                    variant="outlined"
                    required
                    id="planType"
                    label="Plan Type"
                    name="planType"
                    autoComplete="planType"
                    helperText={errors.planType}
                    value={this.state.patient.planType}
                    error={errors.planType ? true : false}
                    onChange={this.handleChange}
                  />
                </Grid>
                <Grid item xs={6}>
                  <TextField
                    className={classes.formTextField}
                    variant="outlined"
                    required
                    id="memberNo"
                    label="Membership Number"
                    name="memberNo"
                    autoComplete="memberNo"
                    helperText={errors.memberNo}
                    value={this.state.patient.memberNo}
                    error={errors.memberNo ? true : false}
                    onChange={this.handleChange}
                  />
                </Grid>
                <Grid item xs={6}>
                  <TextField
                    className={classes.formTextField}
                    variant="outlined"
                    required
                    id="dependentCode"
                    label="Dependent Code"
                    name="dependentCode"
                    autoComplete="dependentCode"
                    helperText={errors.dependentCode}
                    value={this.state.patient.dependentCode}
                    error={errors.dependentCode ? true : false}
                    onChange={this.handleChange}
                  />
                </Grid>
                <Grid item xs={6}>
                  <TextField
                    className={classes.formTextField}
                    variant="outlined"
                    id="principalMember"
                    label="Principal Member"
                    name="principalMember"
                    autoComplete="principalMember"
                    helperText={errors.principalMember}
                    value={this.state.patient.principalMember}
                    error={errors.principalMember ? true : false}
                    onChange={this.handleChange}
                  />
                </Grid>
                <Grid item xs={6}>
                  <TextField
                    className={classes.formTextField}
                    variant="outlined"
                    id="principalId"
                    label="Principal ID"
                    name="principalId"
                    autoComplete="principalId"
                    helperText={errors.principalId}
                    value={this.state.patient.principalId}
                    error={errors.principalId ? true : false}
                    onChange={this.handleChange}
                  />
                </Grid>
                <Grid item xs={6}>
                  <TextField
                    className={classes.formTextField}
                    variant="outlined"
                    id="principalHomeTel"
                    label="Principal Home Tel"
                    name="principalHomeTel"
                    autoComplete="principalHomeTel"
                    helperText={errors.principalHomeTel}
                    value={this.state.patient.principalHomeTel}
                    error={errors.principalHomeTel ? true : false}
                    onChange={this.handleChange}
                  />
                </Grid>
                <Grid item xs={6}>
                  <TextField
                    className={classes.formTextField}
                    variant="outlined"
                    id="principalMobile"
                    label="Principal Mobile"
                    name="principalMobile"
                    autoComplete="principalMobile"
                    helperText={errors.principalMobile}
                    value={this.state.patient.principalMobile}
                    error={errors.principalMobile ? true : false}
                    onChange={this.handleChange}
                  />
                </Grid>
                <Grid item xs={6}>
                  <TextField
                    className={classes.formTextField}
                    variant="outlined"
                    required
                    id="nextOfKin"
                    label="Next of Kin"
                    name="nextOfKin"
                    autoComplete="nextOfKin"
                    helperText={errors.nextOfKin}
                    value={this.state.patient.nextOfKin}
                    error={errors.nextOfKin ? true : false}
                    onChange={this.handleChange}
                  />
                </Grid>
                <Grid item xs={6}>
                  <TextField
                    className={classes.formTextField}
                    variant="outlined"
                    required
                    id="nextOfKinNo"
                    label="Next of Kin Number"
                    name="nextOfKinNo"
                    autoComplete="nextOfKinNo"
                    helperText={errors.nextOfKinNo}
                    value={this.state.patient.nextOfKinNo}
                    error={errors.nextOfKinNo ? true : false}
                    onChange={this.handleChange}
                  />
                </Grid>
                <Grid item xs={6}>
                  <TextField
                    className={classes.formTextField}
                    variant="outlined"
                    required
                    id="referringDoctor"
                    label="Referring Doctor"
                    name="referringDoctor"
                    autoComplete="referringDoctor"
                    helperText={errors.referringDoctor}
                    value={this.state.patient.referringDoctor}
                    error={errors.referringDoctor ? true : false}
                    onChange={this.handleChange}
                  />
                </Grid>
                <Grid item xs={6}>
                  <TextField
                    className={classes.formTextField}
                    variant="outlined"
                    required
                    id="referringDrNo"
                    label="Referring Doctor's Practice Number"
                    name="referringDrNo"
                    autoComplete="referringDrNo"
                    helperText={errors.referringDrNo}
                    value={this.state.patient.referringDrNo}
                    error={errors.referringDrNo ? true : false}
                    onChange={this.handleChange}
                  />
                </Grid>
                <Grid item xs={12}>
                  <SignaturePad
                    key={`${this.state.patient.id || 'new'}-${this.state.patient.signatureSignedAt || 'unsigned'}`}
                    value={this.state.patient.signatureDataUrl || ''}
                    onChange={this.handleSignatureChange}
                    onSignedAtChange={this.handleSignatureSignedAtChange}
                    subtitle="Signature of Patient"
                  />
                  <Typography variant="caption" className={classes.signatureMeta}>
                    {this.state.patient.signatureSignedAt
                      ? `Signed on ${new Date(this.state.patient.signatureSignedAt).toLocaleString()}`
                      : 'No signature captured yet.'}
                  </Typography>
                </Grid>
              </Grid>
            </form>
            {this.state.uiLoading && open ? (
              <div className={classes.dialogBusyOverlay}>
                <CircularProgress size={120} />
              </div>
            ) : null}
        </Dialog>

        <Dialog
          fullScreen
          open={this.state.assessmentDialogOpen}
          onClose={this.handleCloseAssessment}
          TransitionComponent={Transition}
        >
          <AppBar position="static">
            <Toolbar variant="dense">
              <Tooltip title="Close Modal" placement="top">
                <IconButton
                  edge="start"
                  color="inherit"
                  onClick={this.handleCloseAssessment}
                  aria-label="close"
                  size="large"
                >
                  <CloseIcon />
                </IconButton>
              </Tooltip>
              <Typography variant="h6" className={classes.title}>
                {this.state.assessmentMode === 'Edit'
                  ? 'Edit patient wound assessment'
                  : 'Create patient wound assessment'}
              </Typography>
              <Button
                color="inherit"
                onClick={this.handleDownloadAssessmentPdf}
                className={classes.downloadButton}
              >
                Download PDF
              </Button>
              <Button
                autoFocus
                color="inherit"
                onClick={this.handleCreateOrUpdateAssessment}
                className={classes.submitButton}
              >
                {this.state.assessmentMode === 'Edit' ? 'Save' : 'Submit'}
              </Button>
            </Toolbar>
          </AppBar>

          <div ref={(el) => { this.assessmentEditorRef = el }}>
            <AssessmentEditor
              classes={classes}
              assessment={this.state.assessment}
              patient={this.state.patient || {}}
              onChange={this.handleChangeAssessment}
            />
          </div>
          {this.state.uiLoading && this.state.assessmentDialogOpen ? (
            <div className={classes.dialogBusyOverlay}>
              <CircularProgress size={120} />
            </div>
          ) : null}
        </Dialog>
      </main>
    )
  }
}

export default withStyles(styles)(patient)
